var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-2"},[_c('v-card',{staticClass:"mt-2 page-card",attrs:{"elevation":"0 pa-2"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('MyTravelOrderDataTable')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }